import { type FC } from 'react';
import { type NavigationItemsType } from '@common/types/components';
import { Picture } from '@components/ui/Picture/Picture';
import cn from 'classnames';

import goldTicketPng from '/img/icons/ticket-gold.png';
import goldTicketWebp from '/img/icons/ticket-gold.webp';
import arenaPng from '/img/navigation/arena.png';
import arenaWebp from '/img/navigation/arena.webp';
import dicePng from '/img/navigation/dice-usd.png';
import diceWebp from '/img/navigation/dice-usd.webp';
import flagPng from '/img/navigation/Flag.png';
import flagWebp from '/img/navigation/Flag.webp';
import partnersPng from '/img/navigation/partners.png';
import partnersWebp from '/img/navigation/partners.webp';
import shopPng from '/img/navigation/shop.png';
import shopWebp from '/img/navigation/shop.webp';

interface NavigationIconProps {
  name: NavigationItemsType;
  active?: boolean;
}

const NavigationIcon: FC<NavigationIconProps> = ({ name, active }) => {
  const images: Record<
    NavigationItemsType,
    { png: string; webp?: string; extraPng?: string; extraWebp?: string }
  > = {
    partners: {
      png: partnersPng,
      webp: partnersWebp,
    },
    rollCraft: {
      png: dicePng,
      webp: diceWebp,
    },
    tickets: {
      png: goldTicketPng,
      webp: goldTicketWebp,
    },
    arena: {
      png: flagPng,
      webp: flagWebp,
      extraPng: arenaPng,
      extraWebp: arenaWebp,
    },
    shop: {
      png: shopPng,
      webp: shopWebp,
    },
  };

  const image = images[name];

  return (
    <Picture
      className={cn(
        'w-[48px] h-[48px] translate-y-[10px]',
        name === 'rollCraft' && 'w-[56px] h-[48px] -translate-x-[10%]',
        name === 'arena' && 'w-[68px] h-[80px]',
        name === 'arena' && !active && '!translate-y-[14px]',
        name === 'arena' && active && '!translate-y-[-5%]',
        name === 'shop' && 'w-[57px] h-[48px] -translate-x-[2px]',
        name === 'partners' && 'w-[55px] h-[48px] -translate-x-[10%]',
        'shrink-0',
      )}
      img={active ? image.extraPng : image.png}
      webp={active ? image.extraWebp : image.webp}
      alt={name}
    />
  );
};

export { NavigationIcon };
